/* eslint-disable */

import React,{Component} from 'react';  
// import TablePagination from '../Pagination';
var mystyle,tableId;
// var count = 0;
var tableBody = [];
var resetB = false;
// var currentTableBody = [];

//modified table header, value is coming from this.props.mHeaders
var mHeaders=[];
//returns true if object is empty
function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

class TableHeaders extends Component{

    constructor(props){
        super(props);
        this.state = {
            tbody:''
        }
        mystyle = this.props.myStyle ? this.props.myStyle:{}; 
        tableId = this.props.tableId ? this.props.tableId:'table_'; 
        mHeaders = this.props.mHeaders;
        this.makeTableBody = this.makeTableBody.bind(this);
        this.appendIntoTableBody = this.appendIntoTableBody.bind(this);
        // this.displayDataFromChild = this.displayDataFromChild.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentWillReceiveProps(nextProp){
        if(typeof this.props.resetTable === 'boolean'){
            console.log('before '+this.props.resetTable+' next'+nextProp.resetTable)
            if(this.props.resetTable !== nextProp.resetTable){
                console.log('reset');
                tableBody = [];
            }
        }
    }
    // handlePageChange(e){

    // }

    // displayDataFromChild(data){
    //     console.log("data from child methos "+data);
    //     currentTableBody = data;
    // }

    appendIntoTableBody(){
        
        tableBody.unshift(
            <tr key = {this.props.body.number}>
            {
                mHeaders.map(value =>{
                return (
                    //modified headers are value
                    <td key = {value}>  
                    {
                        Object.keys(this.props.body).map((val)=>{
                            if(val === value)
                                return this.props.body[val];
                        })
                    }
                    </td>)
                })
            }
                
            </tr>
        )
        console.log(tableBody.length);
        if(this.props.displayCount){
            this.props.displayCount.value = tableBody.length;
        }
    }

    makeTableBody(){
        var message ='';
        var isMessage = false;
        if(this.props.body.message){
            message = this.props.body.message;
            isMessage = true;
        }
        var size = tableBody.length;
        var b = false;
        if(size > 0){
            for(let i =0 ; i< size; i++){
                console.log(tableBody[i]);
                // console.log('inside maketable body '+tableBody[i].key+ ' '+this.props.body.number);
                console.log(tableBody[i].key);
                if(tableBody[i] && tableBody[i].key && tableBody[i].key !== this.props.body.number){
                    b=true;
                }
                else{
                    console.log("i am false");
                    b=false;
                    break;
                }
            }
        }
        else{
            b = true;
        }
        console.log(b);
        if(b){
            this.appendIntoTableBody();
        }
            
        
    }
    
    render()
    {
        if(isEmpty(this.props.body)){
            tableBody = [];
        }
        else{
            this.makeTableBody();
        }

        return(
            <div>
            <table id={tableId} className = "table table-hover table-bordered" style = {mystyle}>
                <thead>
                    <tr>
                        {this.props.headers.map((value)=>{
                            return <th key = {value}>{value}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    
                    {(tableBody.length > 0)?
                        tableBody.map(value =>{
                        if(value){
                            return value;
                        }
                        else{
                            return null
                        }
                    }):null}
                </tbody>
                
            </table>
            </div>
        )
    }
}

export default TableHeaders;


// WEBPACK FOOTER //
// ./src/Components/Tables.js